import { Outlet } from "react-router-dom";
import {
  Sidebar,
  SidebarContent,
  SidebarGroup,
  SidebarHeader,
  SidebarMenu,
  SidebarProvider,
  SidebarRail,
} from "ui/components/sidebar";
import { NavItem } from "@/components/nav/item";

// Shared sidebar shell for global Integrations, same setup as ProjectLayout.
// `header` is any node for the sidebar header; `items` are NavItem props.
export default function IntegrationSidebarLayout({ name, header, items = [] }) {
  return (
    <>
      <SidebarProvider className="w-fit overflow-hidden max-h-dvh" name={name}>
        <Sidebar collapsible="icon" className="sidebar-height border-r left-auto inset-y-auto top-16">
          <SidebarHeader className="p-0">{header}</SidebarHeader>
          <SidebarContent>
            <SidebarGroup>
              <SidebarMenu>
                {items.map((item) => (
                  <NavItem key={item.url} {...item} />
                ))}
              </SidebarMenu>
            </SidebarGroup>
          </SidebarContent>
          <SidebarRail />
        </Sidebar>
      </SidebarProvider>
      <div className="flex flex-1 flex-col min-w-0">
        <Outlet />
      </div>
    </>
  );
}
